var _path, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-19"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.17,
    y: 160.2,
    width: 351.78,
    height: 15,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.96,
    y: 158.61,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.69,
    y: 158.61,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.43,
    y: 158.61,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.17,
    y: 158.61,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.04,
    y: 158.61,
    width: 23.62,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.87,
    y: 136.19,
    width: 3.96,
    height: 24.79,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.85,
    cy: 134.71,
    r: 10.12,
    transform: "translate(11.02 296.03) rotate(-45)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,134.71a7.19,7.19,0,1,1-7.19-7.19A7.19,7.19,0,0,1,370,134.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.17,
    y: 190.2,
    width: 351.78,
    height: 15,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.96,
    y: 188.61,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.69,
    y: 188.61,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.43,
    y: 188.61,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.17,
    y: 188.61,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.16,221.2v15H319.78a23.79,23.79,0,0,1,23.8,23.8V382.63h15V259.8A38.6,38.6,0,0,0,320,221.2Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.69,
    y: 219.61,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.43,
    y: 219.61,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.17,
    y: 219.61,
    width: 3.44,
    height: 18.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.36,
    y: 372.27,
    width: 3.44,
    height: 18.17,
    transform: "translate(732.44 30.28) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.36,
    y: 267.01,
    width: 3.44,
    height: 18.17,
    transform: "translate(627.18 -74.99) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-19"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-19",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Light--inject-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "257.43 298 189.69 299.17 276.43 231.29 257.43 298",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.43 298 189.69 299.17 276.43 231.29 257.43 298",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.35,
    cy: 199.16,
    r: 100.35,
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.35,
    cy: 199.16,
    r: 100.35,
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Number--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.43,233.38l-9.55-.9-1.17,12.36-7-.66,1.16-12.35L108,229.2l.47-5,28.81-30.48,7.76.73-27.63,29.43,19.33,1.82,1-10.92,6.75.64-1,10.92,9.55.89Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.94,221c1.55-16.37,11.19-24.89,23-23.78S200.5,208.49,199,224.86s-11.18,24.89-22.89,23.79S156.4,237.38,157.94,221Zm33.83,3.19c1.21-12.86-3.64-19.84-11.46-20.58s-14,5.21-15.18,18.07,3.64,19.83,11.54,20.58S190.56,237,191.77,224.19Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.4,242.41l-9.56-.9-1.16,12.36-7-.66,1.17-12.35-27.94-2.63.47-5,28.81-30.48,7.76.73-27.63,29.43,19.32,1.82,1-10.92,6.75.64-1,10.92,9.56.9Z",
    style: {
      fill: "#FBB12D"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.25,173.72l-.42,4.5-18.77-1.77,2.28-24.23,18.32,1.72-.43,4.5-12.74-1.2-.49,5.27,11.25,1.06-.41,4.36-11.25-1.06-.53,5.61Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.73,180.09l-4-7.19-.27,0-4.89-.46-.63,6.75-5.61-.53,2.28-24.24,10.49,1c6.48.61,10.21,4.35,9.7,9.79a7.92,7.92,0,0,1-5.71,7.18l4.71,8.3Zm-3.41-20.16-4.57-.43L154,168l4.57.43c3.43.32,5.31-1.11,5.56-3.74S162.75,160.25,159.32,159.93Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.18,182.49l-4-7.19-.28,0-4.88-.46-.64,6.75-5.6-.53L175,156.8l10.49,1c6.47.61,10.2,4.34,9.69,9.78a7.89,7.89,0,0,1-5.7,7.18l4.7,8.3Zm-3.42-20.16-4.57-.43-.79,8.44,4.57.43c3.43.33,5.31-1.1,5.56-3.73S188.19,162.65,184.76,162.33Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.8,171.17c.68-7.2,6.79-12,14.44-11.29s12.76,6.55,12.08,13.78-6.83,12-14.44,11.29S197.12,178.37,197.8,171.17Zm20.84,2a7.62,7.62,0,1,0-8.31,7A7.42,7.42,0,0,0,218.64,173.13Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.84,187.63l-4-7.19-.27,0-4.89-.45-.63,6.75-5.61-.53,2.28-24.24,10.49,1c6.47.61,10.21,4.35,9.7,9.78a7.92,7.92,0,0,1-5.71,7.19l4.71,8.3Zm-3.41-20.16-4.57-.43-.8,8.45,4.57.43c3.43.32,5.31-1.11,5.56-3.74S242.86,167.79,239.43,167.47Z",
    style: {
      fill: "#FBB12D"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bricks--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.07,409.93a24.81,24.81,0,0,0-2.83-.41,3,3,0,0,1-2.07-1.76c-2.49-1.91-4.23-5.26-5.68-7.41-1-.2-2-.44-2.93-.72l-.06,0a8.46,8.46,0,0,1-5,1.32c-1.88-.14-3.94-2-3.11-4.09.76-1.95,1.92-3.52,4.08-4a14.54,14.54,0,0,1,2.37-.17l.32,0s0,0,.05-.05-.33.16-.17-.1a3,3,0,0,1,3.22-1.45c4-1.43,5.73-1.25,5.73-5.58a7.05,7.05,0,0,1,.27-1.83c0-.57,0-1.14,0-1.72.09-2,1.55-5.46.7-6.88-1-1.63-3.53-2.66-4.68-4.53a3.26,3.26,0,0,1-.18-.38,5.23,5.23,0,0,1-2.47-1.32,2.86,2.86,0,0,1-2.9-.88l-1.63-.28a3,3,0,0,1-1.73.41c-1.33,1.76-4.29,2.5-5.46,0-2.08-4.47-.94-10.39,5.17-9.61a4.55,4.55,0,0,1,2,.79,13.61,13.61,0,0,1,3.06.18,4.87,4.87,0,0,1,2.43-.68h3.92c0-.12,0-.22.06-.35a33.5,33.5,0,0,0,0-5,18.12,18.12,0,0,1,1-7.17l-.34-.75c-4.08-.8-11.39-.42-13.06-.84a2.87,2.87,0,0,1-2.05-1.61,4.1,4.1,0,0,1-1-1.44,14.15,14.15,0,0,1-.91-4,3.15,3.15,0,0,1,1.6-2.79,10.6,10.6,0,0,1,1.53-.61,7.07,7.07,0,0,1,2.12-1.59,4.51,4.51,0,0,1,3.52-1.52h.29a11.26,11.26,0,0,0,3.24-1.82c1.57-1.33,3-2.9,5.31-2.59l.09,0v-12c-6.2-.15-12.51-2.14-16.07-7.53-1.29-2-.14-3.73,1.55-4.41a1.05,1.05,0,0,1,.71-.82l8.81-2.72L404,286.58l-15.4-5.22s-4.11,11.18-9.48,11.14-13.82,10.9-14.74,16.5,5.94,8.19,0,11.13-4,10.47-6.56,15.67c-2.33,4.77-9.91.42-13.65,1.37-6.6,1.69-5,11.57-13.2,12.48-1.77.2-3.57-.1-5.35,0a11.49,11.49,0,0,0-4.6,1.35,3.82,3.82,0,0,0-1.68,1.52c-1.47,2.93,3.74,6.73,1.49,9.11-2.94.31-5.35,2.38-8.07,3.52-6.31,2.63-13.41,0-20.1-1.36a87,87,0,0,0-18.08-1.4c-4.39,0-9.63.26-8,3.94l.36.26a7.61,7.61,0,0,1,2.69,3.61,4.05,4.05,0,0,1,.87,1.31,3.24,3.24,0,0,1-.54,2.88c-1,4.38-6.75,6.48-13.3,7.51a1.21,1.21,0,0,0,.08.77,77.83,77.83,0,0,1-14.48.87,22.65,22.65,0,0,1-5.53-.5c-8,.32-20.44,1.37-27-3-6.33-4.22-5.62-10.59-13.62-13.2-4.47-1.46-3.92-5.08-6.07-8.42-3.12-4.87-8.23-3.2-10.63-8.12-1.61-3.32-6.79-3.27-8.8-6.37-1.14-1.77-.93-4.07-.49-6.13a2.48,2.48,0,0,1,.58-1.32c.39-.37,1-.45,1.41-.78.89-.67.78-2,1.13-3.07,1-3.05,5.2-3.42,6.52-6.2-6.51-4.84-16.7-7.75-15.4-18.2.52-4.15-12.66-6.11-16.35-12s-10.92,3.65-16.54-8.5-29.16-9.53-31.63-9.52-6.78,12.06-13,13.68c-3.78,1-1.22,5.16,1.38,9a3.53,3.53,0,0,1,2.5.29.57.57,0,0,0,.13.08,6.43,6.43,0,0,1,3.23.06c2,.61,3,2.34,3.66,4.17a2.54,2.54,0,0,1,.13,1.12,3.59,3.59,0,0,1,1.06,1.65,3.23,3.23,0,0,1-2.26,4,1.54,1.54,0,0,1-.31.05l-.17.17a3.32,3.32,0,0,1-3.59.25,7.7,7.7,0,0,1-1.28-.73c-.56,1.14-1.81,2.08-4.48,2.65-6.23,1.33-7.72,8.78-6.23,13.38a2.73,2.73,0,0,1,.06,1.57c2.44,0,4.9.29,7.23.34,6.32.26,6.36,10,0,9.85-.33,0-.66,0-1,0a5.3,5.3,0,0,1-3.25,3,22,22,0,0,0-4.09,2.1c.42,3.9,1.25,8.53.72,12.53a16.87,16.87,0,0,1,1.86.5A8.17,8.17,0,0,1,87,362.16a3.2,3.2,0,0,1,3.29-.08,3.25,3.25,0,0,1,1.58,2.6,6.34,6.34,0,0,1,.68.19,2.93,2.93,0,0,1,.4-.19,2.55,2.55,0,0,1,1.25-.28,2.51,2.51,0,0,1,1.24.28,2.46,2.46,0,0,1,1,.67,5.84,5.84,0,0,1,.39.48l.4.31a3.25,3.25,0,0,1,.84,1.43c0,.28.07.57.11.86a2.31,2.31,0,0,1-.28,1.24,2.37,2.37,0,0,1-.67,1,2.31,2.31,0,0,1-1,.67,2.41,2.41,0,0,1-1.24.28,5.92,5.92,0,0,1-.62-.06,2.69,2.69,0,0,1-1.69,1.13,9.29,9.29,0,0,1-5.33-.45,6.67,6.67,0,0,1-2.28.11,7.61,7.61,0,0,1-1.53-.38,12,12,0,0,1-3.59,1.5,92.91,92.91,0,0,1-.15,10.31c0,.4,0,.8,0,1.22A22.85,22.85,0,0,1,86,388.58a4,4,0,0,1,1.45,1.95l.08,0a8.63,8.63,0,0,1,4.4.84c1.93.89,2,3.72.66,5.08-.35.35-.7.67-1.05,1a3.24,3.24,0,0,1-2.36,3,11.19,11.19,0,0,1-1.35.25,6.85,6.85,0,0,1-4.12,1.41h-.19a3.2,3.2,0,0,1-3.11,2.41,5.77,5.77,0,0,0-.72,0h0c.11,0-.65.39-.39.17a4.6,4.6,0,0,0-.81,1,12,12,0,0,1-3.93,3.93,3.15,3.15,0,0,1-1.75.4,32.22,32.22,0,0,0-2.26,3.78H433.34a4.47,4.47,0,0,0,.07-.91A6.26,6.26,0,0,1,430.07,409.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.07,409.93a24.81,24.81,0,0,0-2.83-.41,3,3,0,0,1-2.07-1.76c-2.49-1.91-4.23-5.26-5.68-7.41-1-.2-2-.44-2.93-.72l-.06,0a8.46,8.46,0,0,1-5,1.32c-1.88-.14-3.94-2-3.11-4.09.76-1.95,1.92-3.52,4.08-4a14.54,14.54,0,0,1,2.37-.17l.32,0s0,0,.05-.05-.33.16-.17-.1a3,3,0,0,1,3.22-1.45c4-1.43,5.73-1.25,5.73-5.58a7.05,7.05,0,0,1,.27-1.83c0-.57,0-1.14,0-1.72.09-2,1.55-5.46.7-6.88-1-1.63-3.53-2.66-4.68-4.53a3.26,3.26,0,0,1-.18-.38,5.23,5.23,0,0,1-2.47-1.32,2.86,2.86,0,0,1-2.9-.88l-1.63-.28a3,3,0,0,1-1.73.41c-1.33,1.76-4.29,2.5-5.46,0-2.08-4.47-.94-10.39,5.17-9.61a4.55,4.55,0,0,1,2,.79,13.61,13.61,0,0,1,3.06.18,4.87,4.87,0,0,1,2.43-.68h3.92c0-.12,0-.22.06-.35a33.5,33.5,0,0,0,0-5,18.12,18.12,0,0,1,1-7.17l-.34-.75c-4.08-.8-11.39-.42-13.06-.84a2.87,2.87,0,0,1-2.05-1.61,4.1,4.1,0,0,1-1-1.44,14.15,14.15,0,0,1-.91-4,3.15,3.15,0,0,1,1.6-2.79,10.6,10.6,0,0,1,1.53-.61,7.07,7.07,0,0,1,2.12-1.59,4.51,4.51,0,0,1,3.52-1.52h.29a11.26,11.26,0,0,0,3.24-1.82c1.57-1.33,3-2.9,5.31-2.59l.09,0v-12c-6.2-.15-12.51-2.14-16.07-7.53-1.29-2-.14-3.73,1.55-4.41a1.05,1.05,0,0,1,.71-.82l8.81-2.72L404,286.58l-15.4-5.22s-4.11,11.18-9.48,11.14-13.82,10.9-14.74,16.5,5.94,8.19,0,11.13-4,10.47-6.56,15.67c-2.33,4.77-9.91.42-13.65,1.37-6.6,1.69-5,11.57-13.2,12.48-1.77.2-3.57-.1-5.35,0a11.49,11.49,0,0,0-4.6,1.35,3.82,3.82,0,0,0-1.68,1.52c-1.47,2.93,3.74,6.73,1.49,9.11-2.94.31-5.35,2.38-8.07,3.52-6.31,2.63-13.41,0-20.1-1.36a87,87,0,0,0-18.08-1.4c-4.39,0-9.63.26-8,3.94l.36.26a7.61,7.61,0,0,1,2.69,3.61,4.05,4.05,0,0,1,.87,1.31,3.24,3.24,0,0,1-.54,2.88c-1,4.38-6.75,6.48-13.3,7.51a1.21,1.21,0,0,0,.08.77,77.83,77.83,0,0,1-14.48.87,22.65,22.65,0,0,1-5.53-.5c-8,.32-20.44,1.37-27-3-6.33-4.22-5.62-10.59-13.62-13.2-4.47-1.46-3.92-5.08-6.07-8.42-3.12-4.87-8.23-3.2-10.63-8.12-1.61-3.32-6.79-3.27-8.8-6.37-1.14-1.77-.93-4.07-.49-6.13a2.48,2.48,0,0,1,.58-1.32c.39-.37,1-.45,1.41-.78.89-.67.78-2,1.13-3.07,1-3.05,5.2-3.42,6.52-6.2-6.51-4.84-16.7-7.75-15.4-18.2.52-4.15-12.66-6.11-16.35-12s-10.92,3.65-16.54-8.5-29.16-9.53-31.63-9.52-6.78,12.06-13,13.68c-3.78,1-1.22,5.16,1.38,9a3.53,3.53,0,0,1,2.5.29.57.57,0,0,0,.13.08,6.43,6.43,0,0,1,3.23.06c2,.61,3,2.34,3.66,4.17a2.54,2.54,0,0,1,.13,1.12,3.59,3.59,0,0,1,1.06,1.65,3.23,3.23,0,0,1-2.26,4,1.54,1.54,0,0,1-.31.05l-.17.17a3.32,3.32,0,0,1-3.59.25,7.7,7.7,0,0,1-1.28-.73c-.56,1.14-1.81,2.08-4.48,2.65-6.23,1.33-7.72,8.78-6.23,13.38a2.73,2.73,0,0,1,.06,1.57c2.44,0,4.9.29,7.23.34,6.32.26,6.36,10,0,9.85-.33,0-.66,0-1,0a5.3,5.3,0,0,1-3.25,3,22,22,0,0,0-4.09,2.1c.42,3.9,1.25,8.53.72,12.53a16.87,16.87,0,0,1,1.86.5A8.17,8.17,0,0,1,87,362.16a3.2,3.2,0,0,1,3.29-.08,3.25,3.25,0,0,1,1.58,2.6,6.34,6.34,0,0,1,.68.19,2.93,2.93,0,0,1,.4-.19,2.55,2.55,0,0,1,1.25-.28,2.51,2.51,0,0,1,1.24.28,2.46,2.46,0,0,1,1,.67,5.84,5.84,0,0,1,.39.48l.4.31a3.25,3.25,0,0,1,.84,1.43c0,.28.07.57.11.86a2.31,2.31,0,0,1-.28,1.24,2.37,2.37,0,0,1-.67,1,2.31,2.31,0,0,1-1,.67,2.41,2.41,0,0,1-1.24.28,5.92,5.92,0,0,1-.62-.06,2.69,2.69,0,0,1-1.69,1.13,9.29,9.29,0,0,1-5.33-.45,6.67,6.67,0,0,1-2.28.11,7.61,7.61,0,0,1-1.53-.38,12,12,0,0,1-3.59,1.5,92.91,92.91,0,0,1-.15,10.31c0,.4,0,.8,0,1.22A22.85,22.85,0,0,1,86,388.58a4,4,0,0,1,1.45,1.95l.08,0a8.63,8.63,0,0,1,4.4.84c1.93.89,2,3.72.66,5.08-.35.35-.7.67-1.05,1a3.24,3.24,0,0,1-2.36,3,11.19,11.19,0,0,1-1.35.25,6.85,6.85,0,0,1-4.12,1.41h-.19a3.2,3.2,0,0,1-3.11,2.41,5.77,5.77,0,0,0-.72,0h0c.11,0-.65.39-.39.17a4.6,4.6,0,0,0-.81,1,12,12,0,0,1-3.93,3.93,3.15,3.15,0,0,1-1.75.4,32.22,32.22,0,0,0-2.26,3.78H433.34a4.47,4.47,0,0,0,.07-.91A6.26,6.26,0,0,1,430.07,409.93Z",
    style: {
      fill: "#fafafa",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.63,
    y: 402.19,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.13,
    y: 402.19,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.62,
    y: 402.19,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.12,
    y: 402.19,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.61,
    y: 402.19,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.11,
    y: 402.19,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.6,
    y: 402.19,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.09,
    y: 402.19,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.59,
    y: 402.19,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.63,
    y: 373.43,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.13,
    y: 373.43,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.62,
    y: 373.43,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.12,
    y: 373.43,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.11,
    y: 373.43,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.6,
    y: 373.43,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.09,
    y: 373.43,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.59,
    y: 373.43,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.63,
    y: 344.68,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.13,
    y: 344.68,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.62,
    y: 344.68,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.6,
    y: 344.68,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.09,
    y: 344.68,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.59,
    y: 344.68,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.63,
    y: 315.92,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.13,
    y: 315.92,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.25,
    y: 304.27,
    width: 12.05,
    height: 35.34,
    transform: "translate(-173.3 435.38) rotate(-79.46)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.09,
    y: 315.92,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.59,
    y: 315.92,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.38,
    y: 387.81,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.88,
    y: 387.81,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.37,
    y: 387.81,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.86,
    y: 387.81,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.36,
    y: 387.81,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.85,
    y: 387.81,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.35,
    y: 387.81,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.84,
    y: 387.81,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.38,
    y: 359.05,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.88,
    y: 359.05,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.37,
    y: 359.05,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.86,
    y: 359.05,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.85,
    y: 359.05,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.35,
    y: 359.05,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.84,
    y: 359.05,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.38,
    y: 330.3,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.88,
    y: 330.3,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.35,
    y: 330.3,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.84,
    y: 330.3,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.63,
    y: 287.16,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.43,
    y: 293.53,
    width: 35.34,
    height: 12.05,
    transform: "translate(-107.05 281.68) rotate(-37.27)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.09,
    y: 287.16,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.59,
    y: 287.16,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.38,
    y: 301.54,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.35,
    y: 301.54,
    width: 35.34,
    height: 12.05,
    transform: "matrix(1, -0.09, 0.09, 1, -27.33, 15.47)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.84,
    y: 301.54,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.03,
    y: 261.14,
    width: 12.05,
    height: 35.34,
    transform: "translate(70.74 635.86) rotate(-84.23)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.84,
    y: 272.78,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 388.63,
    y: 402.19,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.13,
    y: 402.19,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.62,
    y: 402.19,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.12,
    y: 402.19,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.61,
    y: 402.19,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.11,
    y: 402.19,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.6,
    y: 402.19,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.09,
    y: 402.19,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.59,
    y: 402.19,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.63,
    y: 373.43,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.13,
    y: 373.43,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.62,
    y: 373.43,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.12,
    y: 373.43,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.11,
    y: 373.43,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.6,
    y: 373.43,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.09,
    y: 373.43,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.59,
    y: 373.43,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.63,
    y: 344.68,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.13,
    y: 344.68,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.62,
    y: 344.68,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.6,
    y: 344.68,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.09,
    y: 344.68,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.59,
    y: 344.68,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.63,
    y: 315.92,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.13,
    y: 315.92,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.25,
    y: 304.27,
    width: 12.05,
    height: 35.34,
    transform: "translate(-173.3 435.38) rotate(-79.46)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.09,
    y: 315.92,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.59,
    y: 315.92,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.38,
    y: 387.81,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.88,
    y: 387.81,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.37,
    y: 387.81,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.86,
    y: 387.81,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.36,
    y: 387.81,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.85,
    y: 387.81,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.35,
    y: 387.81,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.84,
    y: 387.81,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.38,
    y: 359.05,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.88,
    y: 359.05,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.37,
    y: 359.05,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.86,
    y: 359.05,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.85,
    y: 359.05,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.35,
    y: 359.05,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.84,
    y: 359.05,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.38,
    y: 330.3,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.88,
    y: 330.3,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.35,
    y: 330.3,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.84,
    y: 330.3,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.63,
    y: 287.16,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.43,
    y: 293.53,
    width: 35.34,
    height: 12.05,
    transform: "translate(-107.05 281.68) rotate(-37.27)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.09,
    y: 287.16,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.59,
    y: 287.16,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.38,
    y: 301.54,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.35,
    y: 301.54,
    width: 35.34,
    height: 12.05,
    transform: "matrix(1, -0.09, 0.09, 1, -27.33, 15.47)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.84,
    y: 301.54,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.03,
    y: 261.14,
    width: 12.05,
    height: 35.34,
    transform: "translate(70.74 635.86) rotate(-84.23)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.84,
    y: 272.78,
    width: 35.34,
    height: 12.05,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.48,416.52a6.86,6.86,0,0,0-3-2.18c-2.29-.74-2.19-3.11-4.46-4.13s-3.51.09-10.46-.25-2.79-1-11.48-2.78-3.67-.07-7.29-.82-5.85-.89-9.17-1.93-6.15-1.65-9-4.62-5.79-1.27-8.42-1-7.1,1-19.2,2.71-3.68,3.35-6.84,6-8.68-.53-11.31,1.27-9.2,4-13.24,3.81c-3.26-.15-4.86,2.79-5.36,3.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.48,416.52a6.86,6.86,0,0,0-3-2.18c-2.29-.74-2.19-3.11-4.46-4.13s-3.51.09-10.46-.25-2.79-1-11.48-2.78-3.67-.07-7.29-.82-5.85-.89-9.17-1.93-6.15-1.65-9-4.62-5.79-1.27-8.42-1-7.1,1-19.2,2.71-3.68,3.35-6.84,6-8.68-.53-11.31,1.27-9.2,4-13.24,3.81c-3.26-.15-4.86,2.79-5.36,3.93Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.19 403.35 216.97 410.38 249.23 402.52 244.27 395.44 212.19 403.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.19 403.35 216.97 410.38 249.23 402.52 244.27 395.44 212.19 403.35",
    style: {
      fill: "#fafafa",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.93 410.38 253.86 402.45 258.87 405.38 265.43 406.27 257.2 414.72 244.93 410.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.93 410.38 253.86 402.45 258.87 405.38 265.43 406.27 257.2 414.72 244.93 410.38",
    style: {
      fill: "#fafafa",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.7,416.52c-1.25-1.26-3.37-3.24-4.32-3.41a10.67,10.67,0,0,0-4.35,0c-2.37.36-2.17-1.93-4.35-2.73S153.35,408,151,407s-3.76,0-5.34.86-4.75.33-8.87,2.5-7.35,3.86-10.12,4.34a15.25,15.25,0,0,0-4.49,1.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.7,416.52c-1.25-1.26-3.37-3.24-4.32-3.41a10.67,10.67,0,0,0-4.35,0c-2.37.36-2.17-1.93-4.35-2.73S153.35,408,151,407s-3.76,0-5.34.86-4.75.33-8.87,2.5-7.35,3.86-10.12,4.34a15.25,15.25,0,0,0-4.49,1.8Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.07,169H375.8a8.84,8.84,0,0,1,8.85,8.84v15a8.84,8.84,0,0,1-8.85,8.84H347.4l-13,13.9,7-13.9h-8.38a8.84,8.84,0,0,1-8.85-8.84v-15A8.84,8.84,0,0,1,333.07,169Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.16,184.48a5.07,5.07,0,1,1,5.08,4.88A4.84,4.84,0,0,1,335.16,184.48Zm8.77,0a3.71,3.71,0,1,0-3.69,3.66A3.59,3.59,0,0,0,343.93,184.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.52,185.64a3.76,3.76,0,1,1,3.76,3.69A3.59,3.59,0,0,1,346.52,185.64Zm6.19,0a2.44,2.44,0,1,0-2.43,2.54A2.38,2.38,0,0,0,352.71,185.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.32,185.64a3.51,3.51,0,0,1-3.65,3.69,3.1,3.1,0,0,1-2.52-1.17v3.73h-1.31V182h1.25v1.15a3.09,3.09,0,0,1,2.58-1.21A3.5,3.5,0,0,1,363.32,185.64Zm-1.32,0a2.44,2.44,0,1,0-2.44,2.54A2.39,2.39,0,0,0,362,185.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.22,188.48l.54-1a4.73,4.73,0,0,0,2.54.75c1.21,0,1.71-.37,1.71-1,0-1.63-4.56-.22-4.56-3.1,0-1.29,1.16-2.16,3-2.16a5.25,5.25,0,0,1,2.63.65l-.56,1a3.69,3.69,0,0,0-2.08-.58c-1.15,0-1.71.43-1.71,1,0,1.7,4.58.31,4.58,3.12,0,1.31-1.2,2.14-3.12,2.14A5.17,5.17,0,0,1,364.22,188.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.66,188.46a.87.87,0,0,1,.9-.88.88.88,0,0,1,0,1.75A.88.88,0,0,1,371.66,188.46Zm.12-8.75h1.54l-.26,6.53h-1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.14,291.19c.4.41-.85,2.25-2.78,4.12s-3.82,3-4.21,2.63.85-2.25,2.78-4.11S258.75,290.79,259.14,291.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.66,295.84l22.18,23a1.25,1.25,0,0,1,0,1.77l-3.15,3a1.25,1.25,0,0,1-1.78,0l-22.18-23Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.68 296.95 259.77 291.49 252.43 298.58 257.78 301.68 262.68 296.95",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.68 296.95 259.77 291.49 252.43 298.58 257.78 301.68 262.68 296.95",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.62,
    y: 294.19,
    width: 10.99,
    height: 1.71,
    rx: 0.34,
    transform: "translate(-133.06 260.55) rotate(-43.98)",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.53,318.51l.31.32a1.25,1.25,0,0,1,0,1.77l-3.15,3a1.25,1.25,0,0,1-1.78,0l-.31-.32Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.56,305.88h0a.67.67,0,0,1-1,0l-3.46-3.59a.68.68,0,0,1,0-1h0a.69.69,0,0,1,1,0l3.46,3.58A.68.68,0,0,1,266.56,305.88Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.13,261.31c7.29,5.09,13.37,11.58,18.88,18.47,4.82,6.07,7.66,13.38,9.89,20.64a101.78,101.78,0,0,1,3.37,15.49l-6.37,1.56c-4.08-9.87-8.24-20.48-14.86-28.74a178.09,178.09,0,0,0-15.86-14.45c-.63-.52-2-1.58-2.6-2.09l7.55-10.88Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.31,256.91c11-.15,20.41,14.24,20.41,14.24l-11.1,11.72s-11.82-6.74-18.3-12.47C326.32,263.33,334.92,257,343.31,256.91Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.24,
    y: 262.68,
    width: 0.53,
    height: 4.19,
    transform: "translate(-71.11 383.96) rotate(-52.06)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.49,259l-.76-.59a18.87,18.87,0,0,0-1.76-.69l2.19,1.7Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.59,268.29l-.43-.53-.1.12Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.64,
    y: 260.03,
    width: 0.53,
    height: 3.87,
    transform: "translate(-70.28 380.04) rotate(-52.06)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.72,261l-1.08-.84a4.48,4.48,0,0,0-.4.36l1.15.9Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.72,
    y: 268.92,
    width: 0.53,
    height: 3.87,
    transform: "translate(-79.93 378.13) rotate(-52.08)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.86,
    y: 262.04,
    width: 0.53,
    height: 3.82,
    transform: "translate(-77.92 368.35) rotate(-52.06)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.32,
    y: 271.57,
    width: 0.53,
    height: 4.19,
    transform: "translate(-80.77 381.99) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.46,
    y: 264.63,
    width: 0.53,
    height: 4.24,
    transform: "translate(-78.74 372.31) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.14 276.77 356.59 278.68 356.96 278.29 354.47 276.34 354.14 276.77",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.19,
    y: 264.41,
    width: 2.62,
    height: 3.87,
    transform: "translate(-75.04 379.08) rotate(-52.07)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.33,
    y: 257.53,
    width: 2.62,
    height: 3.82,
    transform: "translate(-73 369.44) rotate(-52.07)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.93,
    y: 260.12,
    width: 2.62,
    height: 4.24,
    transform: "translate(-73.83 373.34) rotate(-52.07)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.01 273.08 359.82 275.27 361.63 273.36 358.62 271.02 357.01 273.08",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.79,
    y: 267.06,
    width: 2.62,
    height: 4.19,
    transform: "translate(-75.86 383.01) rotate(-52.07)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.44,
    y: 266.37,
    width: 2.62,
    height: 3.82,
    transform: "translate(-82.63 367.43) rotate(-52.07)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.3,
    y: 273.25,
    width: 2.62,
    height: 3.87,
    transform: "translate(-84.66 377.07) rotate(-52.07)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.22,263.88a4.76,4.76,0,0,0,0,1.6l.78-1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.4,281.57l2.22,1.3,1.26-1.33-2.15-1.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.36,275.68l-1.61,2.06,2.19,1.7,1.21.76,1.52-1.95Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.04,
    y: 268.97,
    width: 2.62,
    height: 4.24,
    transform: "translate(-83.46 371.33) rotate(-52.07)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.14,267.91c.07.11.14.22.22.33l.08-.1Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.05,257.09l-.25,0,.14.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.78,262.56l2.55-3.26L337.59,258l-.75.29L334.72,261Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.26,
    y: 262.42,
    width: 3.92,
    height: 2.62,
    transform: "translate(-79.24 365.25) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.32,
    y: 260.66,
    width: 0.53,
    height: 2.62,
    transform: "translate(-77.33 365.64) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.32,
    y: 260.66,
    width: 0.53,
    height: 2.62,
    transform: "translate(-77.33 365.64) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.94,257.24l-.14-.11a17,17,0,0,0-3.21.82l1.74,1.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.94,257.24l-.14-.11a17,17,0,0,0-3.21.82l1.74,1.35Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.44,268.14l1.6-2.06L332,264.47l-.78,1a6.32,6.32,0,0,0,.94,2.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.44,268.14l1.6-2.06L332,264.47l-.78,1a6.32,6.32,0,0,0,.94,2.43Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.1,
    y: 269.31,
    width: 3.92,
    height: 2.62,
    transform: "translate(-81.27 374.87) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.55,260.57l.35-.44a23.74,23.74,0,0,0-2.28-1.33l-.13.16Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.98,
    y: 260.45,
    width: 3.98,
    height: 2.62,
    transform: "translate(-71.63 376.87) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.8,
    y: 265.71,
    width: 4.14,
    height: 2.62,
    transform: "translate(-77.35 375.68) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.22,273.42l-.42.54c.7.51,1.41,1,2.13,1.52l.35-.45Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.09,
    y: 258.67,
    width: 0.53,
    height: 2.62,
    transform: "translate(-69.68 377.31) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.09,
    y: 258.67,
    width: 0.53,
    height: 2.62,
    transform: "translate(-69.68 377.31) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.16,
    y: 267.55,
    width: 0.53,
    height: 2.62,
    transform: "translate(-79.34 375.34) rotate(-52.08)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.16,
    y: 267.55,
    width: 0.53,
    height: 2.62,
    transform: "translate(-79.34 375.34) rotate(-52.08)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.63,
    y: 263.05,
    width: 2.62,
    height: 2.62,
    transform: "translate(-74.45 376.31) rotate(-52.07)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.63,
    y: 263.05,
    width: 2.62,
    height: 2.62,
    transform: "translate(-74.45 376.31) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.74,
    y: 271.89,
    width: 2.62,
    height: 2.62,
    transform: "translate(-84.08 374.28) rotate(-52.07)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.74,
    y: 271.89,
    width: 2.62,
    height: 2.62,
    transform: "translate(-84.08 374.28) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.86,266.27l-.46-.51-.07.09Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.82,
    y: 267.34,
    width: 3.98,
    height: 2.62,
    transform: "translate(-73.64 386.55) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.94,
    y: 276.2,
    width: 3.92,
    height: 2.62,
    transform: "translate(-83.3 384.47) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.64,
    y: 272.6,
    width: 4.14,
    height: 2.62,
    transform: "translate(-79.38 385.32) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,266.27l2.06,1.61.1-.12c-.39-.47-.83-1-1.3-1.49l-.53-.42Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,266.27l2.06,1.61.1-.12c-.39-.47-.83-1-1.3-1.49l-.53-.42Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353,
    y: 274.44,
    width: 0.53,
    height: 2.62,
    transform: "translate(-81.39 384.88) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353,
    y: 274.44,
    width: 0.53,
    height: 2.62,
    transform: "translate(-81.39 384.88) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.48,
    y: 269.94,
    width: 2.62,
    height: 2.62,
    transform: "translate(-76.48 385.94) rotate(-52.07)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.48,
    y: 269.94,
    width: 2.62,
    height: 2.62,
    transform: "translate(-76.48 385.94) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.67,278.25l-1.52,1.95,2.25,1.37,1.33-1.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.67,278.25l-1.52,1.95,2.25,1.37,1.33-1.71Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.45,270.49,335,271l.41.34.43-.54Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.21,
    y: 263.17,
    width: 4.14,
    height: 0.53,
    transform: "translate(-76.3 370.7) rotate(-52.07)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.51,
    y: 266.77,
    width: 3.92,
    height: 0.53,
    transform: "translate(-80.22 369.87) rotate(-52.07)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.37,259.91l2.07-2.66a5.59,5.59,0,0,0-.59-.11l-1.91,2.44Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.57,
    y: 265.02,
    width: 0.53,
    height: 0.53,
    transform: "translate(-78.3 370.28) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.57,
    y: 265.02,
    width: 0.53,
    height: 0.53,
    transform: "translate(-78.3 370.28) rotate(-52.07)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.04,
    y: 260.51,
    width: 2.62,
    height: 0.53,
    transform: "translate(-73.39 371.32) rotate(-52.07)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.04,
    y: 260.51,
    width: 2.62,
    height: 0.53,
    transform: "translate(-73.39 371.32) rotate(-52.07)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.15,
    y: 269.35,
    width: 2.62,
    height: 0.53,
    transform: "translate(-83.03 369.28) rotate(-52.07)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.15,
    y: 269.35,
    width: 2.62,
    height: 0.53,
    transform: "translate(-83.03 369.28) rotate(-52.07)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.4,
    y: 273.7,
    width: 3.92,
    height: 0.53,
    transform: "translate(-82.25 379.56) rotate(-52.07)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,263.28l.36-.47-.4-.35-.38.49Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.33,277.41l-.18.24.44.29.16-.2Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.27,
    y: 264.83,
    width: 3.98,
    height: 0.53,
    transform: "translate(-72.6 381.57) rotate(-52.07)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.09,
    y: 270.1,
    width: 4.14,
    height: 0.53,
    transform: "translate(-78.33 380.38) rotate(-52.07)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.38,
    y: 263.06,
    width: 0.53,
    height: 0.53,
    transform: "translate(-70.67 381.98) rotate(-52.07)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.38,
    y: 263.06,
    width: 0.53,
    height: 0.53,
    transform: "translate(-70.67 381.98) rotate(-52.07)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.46,
    y: 271.94,
    width: 0.53,
    height: 0.53,
    transform: "translate(-80.37 379.83) rotate(-52.05)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.46,
    y: 271.94,
    width: 0.53,
    height: 0.53,
    transform: "translate(-80.37 379.83) rotate(-52.05)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.93,
    y: 267.43,
    width: 2.62,
    height: 0.53,
    transform: "translate(-75.43 380.99) rotate(-52.07)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.93,
    y: 267.43,
    width: 2.62,
    height: 0.53,
    transform: "translate(-75.43 380.99) rotate(-52.07)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.04,
    y: 276.28,
    width: 2.62,
    height: 0.53,
    transform: "translate(-85.07 378.91) rotate(-52.06)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.04,
    y: 276.28,
    width: 2.62,
    height: 0.53,
    transform: "translate(-85.07 378.91) rotate(-52.06)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.72,271.15l-.11-.16-1.16,1.5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.59 282.39 362.19 267.4 364.96 270.55 352.87 284.17 350.59 282.39",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.96 270.55 360.63 275.43 353.22 283.78 352.87 284.18 350.59 282.39 350.73 282.21 350.97 281.91 358.18 272.59 361.55 268.23 362.19 267.4 364.96 270.55",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.63,275.43l-7.41,8.35a11.55,11.55,0,0,1-2.49-1.57,10,10,0,0,1-1.19-1.16c-2.51-2.88-3.7-7.43-1.2-13.64a26.12,26.12,0,0,1,9.84,5.18,14.28,14.28,0,0,1,2.05,2.26A6,6,0,0,1,360.63,275.43Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.32,238.44c-.06.63-.53,1.08-.94,1s-.65-.63-.56-1.26.53-1.08.94-1S305.41,237.84,305.32,238.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.73,239.09a23.06,23.06,0,0,1-3.89,4.9,3.73,3.73,0,0,0,2.93,1.06Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.14,234.66h0a.37.37,0,0,0-.4.34.4.4,0,0,0,.09.2.39.39,0,0,0,.24.21,3,3,0,0,1,2.32,1.39.4.4,0,0,0,.51.17h0a.37.37,0,0,0,.16-.5A3.7,3.7,0,0,0,305.14,234.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.33,247.88a10.81,10.81,0,0,0,.22,1.16,11.06,11.06,0,0,0,3.35,5.71,10.68,10.68,0,0,0,1.35,1.06,10.07,10.07,0,0,0,12.16-.55c4.46-3.58,4.88-8.26,6.23-16.11a10.91,10.91,0,0,0-13.72-12.49C305.82,228.94,303.42,240.57,304.33,247.88Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.9,254.75a10.68,10.68,0,0,0,1.35,1.06,10.08,10.08,0,0,0,8.6,1.36,12.1,12.1,0,0,0-1.1-2.84A15.73,15.73,0,0,0,307.9,254.75Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.4,260.49c-1.78,5.1-11,8.59-11,8.59s-6.17,1.44-5.95-.84c2.88-2.24,3.6-4.55,3.21-6.78a10.39,10.39,0,0,0-1.64-3.78c-.41-.65-2.29-2.49-2.78-3.09L318,242.16C319.43,248.11,322.92,258.59,328.4,260.49Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.84,223.16c2.16-.65,8-1,11.43.3,10.55,4.16,8.49,10.38,8.49,10.38a7.61,7.61,0,0,0-2.46-3.36c7.23,15.23-8.39,24.29-8.39,24.29-4.11-2.53-10.06-1.75-10.06-1.75s-.36-7.3-2-9.84-2.2-7.57-1.16-10.21-1.87-1.7-1.87-1.7C306.07,229.11,310.68,224.11,313.84,223.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.86,242.25a5.16,5.16,0,0,1-3,3.21c-1.69.5-2.49-1.89-2-4.24.46-2.08,1.89-4.92,3.56-4.33S314.66,240.18,313.86,242.25Z",
    style: {
      fill: "#ffc3bd"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M311.94,229.91s-7,16.66-5.47,23.27c0,0-3.26-4.91,3.95-23Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.79,229.75s3.88,8.6,8.17,11.62,7.1.86,7.1.86l1.4-5.34s-1.42,4-3.48,3.62-6.12-3-9.33-10.09Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.79,229.75s3.88,8.6,8.17,11.62,7.1.86,7.1.86l1.4-5.34s-1.42,4-3.48,3.62-6.12-3-9.33-10.09Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.18,230.73s2.32-7.69,6.59-10,13.41-.92,18.33,2.51,5.1,11.59,4.75,13.1c-.81,3.5-10.89-7.22-18.94-7.37S305.18,230.73,305.18,230.73Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.18,230.73s2.32-7.69,6.59-10,13.41-.92,18.33,2.51,5.1,11.59,4.75,13.1c-.81,3.5-10.89-7.22-18.94-7.37S305.18,230.73,305.18,230.73Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.07,220.15s1.88-3.53,3.42-4,11.66,2.14,14.11,4.46,4.79,9.28,3.2,15.78l-4.95-1.2s1.22-7.6-2.18-11.2C322.75,219.82,313.07,220.15,313.07,220.15Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.43,233.59s3.45,2.39,8.33-1.09,11.57-1.21,16.3,2a35.45,35.45,0,0,0,11,5l-2.17-3.21s-4.15-.61-10-5.29-16.28-3.65-19.7-.29Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.9,264.4s4.94-7.76,13.48-8.42,5.55,8.42,5.55,8.42Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.9,264.4s4.94-7.76,13.48-8.42,5.55,8.42,5.55,8.42Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.77,305.36c-12.56,4-35.59,11.4-41.7,13.37-1.42-3.77-.26-15.15-6.62-27.61a48.88,48.88,0,0,0-7.23-10.43,59.17,59.17,0,0,0-10.07-8.83S318.2,256,340.79,257.39C340.79,257.39,360,269.12,365.77,305.36Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.82,
    y: 263.04,
    width: 4.24,
    height: 0.53,
    transform: "translate(-66 115.61) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.7,
    y: 264.47,
    width: 3.82,
    height: 0.53,
    transform: "translate(-66.67 114.33) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.12,
    y: 266.56,
    width: 4.3,
    height: 0.53,
    transform: "translate(-67.63 112.41) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.94,270.94l-2.79.92h0l.53.39,2.44-.81Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.06,
    y: 267.98,
    width: 3.76,
    height: 0.53,
    transform: "translate(-68.29 111.13) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.52,
    y: 259.52,
    width: 4.19,
    height: 0.53,
    transform: "translate(-64.35 118.74) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.35,
    y: 260.95,
    width: 3.87,
    height: 0.53,
    transform: "translate(-65.02 117.45) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.42,
    y: 270.07,
    width: 4.35,
    height: 0.53,
    transform: "translate(-69.28 109.29) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.34,258.51l-.25-.2.08.25Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.23,
    y: 275.16,
    width: 3.82,
    height: 0.53,
    transform: "translate(-69.84 115.96) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.65,
    y: 277.25,
    width: 4.3,
    height: 0.53,
    transform: "translate(-70.82 114.09) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.35,
    y: 273.73,
    width: 4.24,
    height: 0.53,
    transform: "translate(-69.16 117.22) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.87,
    y: 271.65,
    width: 3.87,
    height: 0.53,
    transform: "translate(-68.19 119.1) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.94,267.87l1-.33-.34-.45-.82.27Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.05,
    y: 270.22,
    width: 4.19,
    height: 0.53,
    transform: "translate(-67.54 120.43) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.52,
    y: 268.13,
    width: 3.93,
    height: 0.53,
    transform: "translate(-66.55 122.26) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 278.68,
    width: 3.76,
    height: 0.53,
    transform: "translate(-71.48 112.81) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.11,280.1l-1.09.36c.13.15.25.3.38.44l.88-.29Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.04,
    y: 278.82,
    width: 3.93,
    height: 0.53,
    transform: "translate(-69.74 123.94) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.18,
    y: 287.95,
    width: 4.3,
    height: 0.53,
    transform: "translate(-73.99 115.73) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.58,
    y: 280.91,
    width: 4.19,
    height: 0.53,
    transform: "translate(-70.71 122.06) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.88,
    y: 284.43,
    width: 4.24,
    height: 0.53,
    transform: "translate(-72.35 118.9) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.4,
    y: 282.34,
    width: 3.87,
    height: 0.53,
    transform: "translate(-71.46 120.98) rotate(-18.28)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.11,
    y: 289.38,
    width: 3.76,
    height: 0.53,
    transform: "translate(-74.65 114.43) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.46,278.56l3.56-1.17c-.09-.16-.17-.32-.25-.48l-3.47,1.15Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.76,
    y: 285.86,
    width: 3.82,
    height: 0.53,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -73.02, 117.61)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.4,
    y: 295.13,
    width: 4.24,
    height: 0.53,
    transform: "translate(-75.51 120.5) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.93,
    y: 293.04,
    width: 3.87,
    height: 0.53,
    transform: "translate(-74.55 122.42) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.8,
    y: 288.09,
    width: 4.13,
    height: 0.53,
    transform: "translate(-72.25 126.87) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.57,
    y: 289.52,
    width: 3.93,
    height: 0.53,
    transform: "translate(-72.9 125.57) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.22,299.5l-3.15,1c0,.18.09.35.14.52l3.18-1.05Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.28,
    y: 296.56,
    width: 3.82,
    height: 0.53,
    transform: "translate(-76.19 119.26) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.7,
    y: 298.65,
    width: 4.3,
    height: 0.53,
    transform: "translate(-77.16 117.38) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 291.61,
    width: 4.19,
    height: 0.53,
    transform: "translate(-73.88 123.7) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.45,
    y: 303.74,
    width: 3.87,
    height: 0.53,
    transform: "translate(-77.7 124.02) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.23,
    y: 309.35,
    width: 4.3,
    height: 0.53,
    transform: "translate(-80.31 118.98) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.93,
    y: 305.83,
    width: 4.24,
    height: 0.53,
    transform: "translate(-78.68 122.14) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.17,
    y: 310.78,
    width: 3.76,
    height: 0.53,
    transform: "translate(-81 117.73) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.33,
    y: 298.79,
    width: 4.13,
    height: 0.53,
    transform: "translate(-75.42 128.51) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.81,
    y: 307.26,
    width: 3.82,
    height: 0.53,
    transform: "translate(-79.36 120.89) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.1,
    y: 300.22,
    width: 3.93,
    height: 0.53,
    transform: "translate(-76.08 127.22) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.63,
    y: 302.31,
    width: 4.19,
    height: 0.53,
    transform: "translate(-77.04 125.31) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.09,260.11l-.15-.47c-1.24.38-2.45.79-3.61,1.23l.14.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.63,258.61l-.05-.16c-1.41.3-2.79.65-4.13,1l.15.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.89,261.83q-1.41.6-2.73,1.23l2.83-.94Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.47,
    y: 268.8,
    width: 3.82,
    height: 2.62,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -68.26, 115.15)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.59,
    y: 267.37,
    width: 4.24,
    height: 2.62,
    transform: "translate(-67.61 116.46) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,273.79l-4.13,1.37.17.53c.61.53,1.21,1.05,1.77,1.58l3-1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.27,264.93l3.57-1.18c-.69-.78-1.36-1.47-2-2.1l-2.41.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.29,
    y: 263.85,
    width: 4.19,
    height: 2.62,
    transform: "translate(-65.96 119.59) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.12,
    y: 265.28,
    width: 3.87,
    height: 2.62,
    transform: "translate(-66.63 118.32) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.83,
    y: 272.32,
    width: 3.76,
    height: 2.62,
    transform: "translate(-69.9 111.99) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.9,
    y: 270.89,
    width: 4.3,
    height: 2.62,
    transform: "translate(-69.24 113.28) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.63,
    y: 275.93,
    width: 3.87,
    height: 2.62,
    transform: "translate(-69.78 119.95) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.41,
    y: 281.54,
    width: 4.3,
    height: 2.62,
    transform: "translate(-72.4 114.93) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.98,
    y: 279.45,
    width: 3.82,
    height: 2.62,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -71.42, 116.79)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,274.18l2.73-.9c-.47-.8-.94-1.56-1.42-2.29l-2.13.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.1,
    y: 278.02,
    width: 4.24,
    height: 2.62,
    transform: "translate(-70.76 118.09) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.8,
    y: 274.5,
    width: 4.19,
    height: 2.62,
    transform: "translate(-69.12 121.25) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.34,
    y: 282.97,
    width: 3.76,
    height: 2.62,
    transform: "translate(-73.06 113.63) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.27,
    y: 272.41,
    width: 3.93,
    height: 2.62,
    transform: "translate(-68.14 123.12) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.61,
    y: 288.66,
    width: 4.24,
    height: 2.62,
    transform: "translate(-73.92 119.71) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.49,
    y: 290.09,
    width: 3.82,
    height: 2.62,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -74.58, 118.42)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.11,293.09l-3.25,1.07c.34.82.67,1.63,1,2.44l3.1-1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.78,
    y: 283.06,
    width: 3.93,
    height: 2.62,
    transform: "translate(-71.3 124.76) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.92,
    y: 292.18,
    width: 4.3,
    height: 2.62,
    transform: "translate(-75.55 116.54) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.14,
    y: 286.58,
    width: 3.87,
    height: 2.62,
    transform: "translate(-72.94 121.58) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.31,
    y: 285.15,
    width: 4.19,
    height: 2.62,
    transform: "translate(-72.28 122.88) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.01,
    y: 281.63,
    width: 4.13,
    height: 2.62,
    transform: "translate(-70.64 126.06) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.65,
    y: 297.22,
    width: 3.87,
    height: 2.62,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -76.11, 123.24)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 300.74,
    width: 3.82,
    height: 2.62,
    transform: "translate(-77.74 120.07) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.52,
    y: 292.27,
    width: 4.13,
    height: 2.62,
    transform: "translate(-73.79 127.67) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.43,
    y: 302.83,
    width: 4.3,
    height: 2.62,
    transform: "translate(-78.71 118.18) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.43,306.22l-.81-2.48-3.55,1.16c0,.08,0,.15.05.23l.74,2.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.29,
    y: 293.7,
    width: 3.93,
    height: 2.62,
    transform: "translate(-74.46 126.38) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.82,
    y: 295.79,
    width: 4.19,
    height: 2.62,
    transform: "translate(-75.43 124.5) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.12,
    y: 299.31,
    width: 4.24,
    height: 2.62,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -77.07, 121.33)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.51,
    y: 311.39,
    width: 3.82,
    height: 2.62,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -80.89, 121.69)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.63,
    y: 309.96,
    width: 4.24,
    height: 2.62,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -80.24, 123)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.55,306.12l3.17-1.05c-.14-.88-.29-1.75-.45-2.6l-3.54,1.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.8,
    y: 304.35,
    width: 3.93,
    height: 2.62,
    transform: "translate(-77.62 128.04) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.72,312.87l-4.09,1.34.82,2.47,2-.64,2.09-.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.16,
    y: 307.87,
    width: 3.87,
    height: 2.62,
    transform: "translate(-79.24 124.82) rotate(-18.24)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.55,315.56l.81,2.43,3.58-1.15-.81-2.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.33,
    y: 306.44,
    width: 4.19,
    height: 2.62,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -78.59, 126.14)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.34,311.89l-1.24.41c.15,1.5.28,2.82.43,3.93l2-.67Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.86,307.4l-.34.11c.23,1.52.39,2.94.53,4.24l1.13-.37Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.13,290.54l.47.91-.31-1Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.41,
    y: 275.77,
    width: 2.62,
    height: 4.03,
    transform: "translate(-71.31 111.58) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.33,
    y: 269.4,
    width: 2.62,
    height: 4.09,
    transform: "translate(-69.42 110.6) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.84,286.11l-1.13.37c.8,1.2,1.52,2.39,2.17,3.58l.24-.08Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.07,268.59l-1-2.9c-.81.47-1.58.94-2.29,1.38l.76,2.34Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.76,279.79l-2.48.82.71,2.16c.4.49.79,1,1.15,1.47l1.88-.62Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.6,
    y: 268.98,
    width: 2.62,
    height: 0.53,
    transform: "translate(-68.76 110.23) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.6,
    y: 268.98,
    width: 2.62,
    height: 0.53,
    transform: "translate(-68.76 110.23) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.13,
    y: 279.68,
    width: 2.62,
    height: 0.53,
    transform: "translate(-71.94 111.89) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.13,
    y: 279.68,
    width: 2.62,
    height: 0.53,
    transform: "translate(-71.94 111.89) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.12,290l-.24.08.25.48.16-.05Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.12,290l-.24.08.25.48.16-.05Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.18,311.38l-1.13.37c0,.19,0,.37.05.55l1.24-.41Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.18,311.38l-1.13.37c0,.19,0,.37.05.55l1.24-.41Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.37,
    y: 273.32,
    width: 2.62,
    height: 2.62,
    transform: "translate(-70.38 111.11) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.37,
    y: 273.32,
    width: 2.62,
    height: 2.62,
    transform: "translate(-70.38 111.11) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,283.62l-1.88.62c.56.75,1.08,1.49,1.57,2.24l1.13-.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,283.62l-1.88.62c.56.75,1.08,1.49,1.57,2.24l1.13-.37Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.12,305.13c.15.81.28,1.61.4,2.38l.34-.11Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.12,305.13c.15.81.28,1.61.4,2.38l.34-.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.53,316.23a11.75,11.75,0,0,0,.54,2.49l2.29-.73-.81-2.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.53,316.23a11.75,11.75,0,0,0,.54,2.49l2.29-.73-.81-2.43Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.06,
    y: 272.26,
    width: 2.62,
    height: 4.03,
    transform: "translate(-69.67 114.73) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.49,
    y: 276.59,
    width: 2.62,
    height: 4.03,
    transform: "translate(-70.96 115.4) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.53,
    y: 297.99,
    width: 2.62,
    height: 3.92,
    transform: "translate(-77.28 118.67) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.97,
    y: 265.89,
    width: 2.62,
    height: 4.09,
    transform: "translate(-67.79 113.77) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.62,
    y: 304.19,
    width: 2.62,
    height: 4.19,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -79.16, 119.65)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.01,
    y: 287.29,
    width: 2.62,
    height: 3.98,
    transform: "translate(-74.12 117.03) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.58,
    y: 282.9,
    width: 2.62,
    height: 4.08,
    transform: "translate(-72.84 116.37) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.1,
    y: 293.55,
    width: 2.62,
    height: 4.14,
    transform: "translate(-76 118.01) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.54,315.35v0l2.49-.8v0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.54,
    y: 261.61,
    width: 2.62,
    height: 3.97,
    transform: "translate(-66.5 113.09) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.05,
    y: 308.69,
    width: 2.62,
    height: 3.87,
    transform: "translate(-80.45 120.32) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.25,
    y: 265.47,
    width: 2.62,
    height: 0.53,
    transform: "translate(-67.19 113.54) rotate(-18.27)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.25,
    y: 265.47,
    width: 2.62,
    height: 0.53,
    transform: "translate(-67.19 113.54) rotate(-18.27)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.77,
    y: 276.17,
    width: 2.62,
    height: 0.53,
    transform: "translate(-70.31 115.06) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.77,
    y: 276.17,
    width: 2.62,
    height: 0.53,
    transform: "translate(-70.31 115.06) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.3,
    y: 286.87,
    width: 2.62,
    height: 0.53,
    transform: "translate(-73.49 116.72) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.3,
    y: 286.87,
    width: 2.62,
    height: 0.53,
    transform: "translate(-73.49 116.72) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.83,
    y: 297.57,
    width: 2.62,
    height: 0.53,
    transform: "translate(-76.66 118.35) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.83,
    y: 297.57,
    width: 2.62,
    height: 0.53,
    transform: "translate(-76.66 118.35) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.36,
    y: 308.27,
    width: 2.62,
    height: 0.53,
    transform: "translate(-79.88 120.1) rotate(-18.26)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.36,
    y: 308.27,
    width: 2.62,
    height: 0.53,
    transform: "translate(-79.88 120.1) rotate(-18.26)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.47,261.3l-.14-.43c-.84.31-1.65.63-2.44,1l.1.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.47,261.3l-.14-.43c-.84.31-1.65.63-2.44,1l.1.29Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.02,
    y: 269.81,
    width: 2.62,
    height: 2.62,
    transform: "translate(-68.72 114.22) rotate(-18.24)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.02,
    y: 269.81,
    width: 2.62,
    height: 2.62,
    transform: "translate(-68.72 114.22) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.53,
    y: 280.45,
    width: 2.62,
    height: 2.62,
    transform: "translate(-71.88 115.87) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.53,
    y: 280.45,
    width: 2.62,
    height: 2.62,
    transform: "translate(-71.88 115.87) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.04,
    y: 291.1,
    width: 2.62,
    height: 2.62,
    transform: "translate(-75.05 117.53) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.04,
    y: 291.1,
    width: 2.62,
    height: 2.62,
    transform: "translate(-75.05 117.53) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.55,
    y: 301.75,
    width: 2.62,
    height: 2.62,
    transform: "translate(-78.21 119.15) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.55,
    y: 301.75,
    width: 2.62,
    height: 2.62,
    transform: "translate(-78.21 119.15) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.06,
    y: 312.39,
    width: 2.62,
    height: 2.62,
    transform: "translate(-81.35 120.76) rotate(-18.24)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.06,
    y: 312.39,
    width: 2.62,
    height: 2.62,
    transform: "translate(-81.35 120.76) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.65,
    y: 283.78,
    width: 2.62,
    height: 3.98,
    transform: "translate(-72.49 120.21) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.69,
    y: 305.18,
    width: 2.62,
    height: 3.87,
    transform: "translate(-78.81 123.46) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.88,262.39l2.48-.82L330.17,258l-1.17.2-1.37.45Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.26,
    y: 300.68,
    width: 2.62,
    height: 4.19,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -77.53, 122.8)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.23,
    y: 279.39,
    width: 2.62,
    height: 4.08,
    transform: "translate(-71.2 119.54) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.71,
    y: 268.75,
    width: 2.62,
    height: 4.03,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -68.04, 117.91)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.18,311.84l0,.11,2.49-.8,0-.13Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.62,
    y: 262.38,
    width: 2.62,
    height: 4.09,
    transform: "translate(-66.16 116.92) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.17,
    y: 294.48,
    width: 2.62,
    height: 3.92,
    transform: "translate(-75.65 121.83) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.14,
    y: 273.08,
    width: 2.62,
    height: 4.03,
    transform: "translate(-69.32 118.56) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.74,
    y: 290.04,
    width: 2.62,
    height: 4.14,
    transform: "translate(-74.36 121.16) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.89,
    y: 261.96,
    width: 2.62,
    height: 0.53,
    transform: "translate(-65.49 116.54) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.89,
    y: 261.96,
    width: 2.62,
    height: 0.53,
    transform: "translate(-65.49 116.54) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.42,
    y: 272.66,
    width: 2.62,
    height: 0.53,
    transform: "translate(-68.68 118.23) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.42,
    y: 272.66,
    width: 2.62,
    height: 0.53,
    transform: "translate(-68.68 118.23) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.95,
    y: 283.36,
    width: 2.62,
    height: 0.53,
    transform: "translate(-71.85 119.87) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.95,
    y: 283.36,
    width: 2.62,
    height: 0.53,
    transform: "translate(-71.85 119.87) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.48,
    y: 294.06,
    width: 2.62,
    height: 0.53,
    transform: "translate(-75.01 121.47) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.48,
    y: 294.06,
    width: 2.62,
    height: 0.53,
    transform: "translate(-75.01 121.47) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 304.76,
    width: 2.62,
    height: 0.53,
    transform: "translate(-78.24 123.26) rotate(-18.26)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 304.76,
    width: 2.62,
    height: 0.53,
    transform: "translate(-78.24 123.26) rotate(-18.26)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.63,258.61l1.37-.45-1.42.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.63,258.61l1.37-.45-1.42.29Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.67,
    y: 266.3,
    width: 2.62,
    height: 2.62,
    transform: "translate(-67.09 117.38) rotate(-18.24)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.67,
    y: 266.3,
    width: 2.62,
    height: 2.62,
    transform: "translate(-67.09 117.38) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.18,
    y: 276.94,
    width: 2.62,
    height: 2.62,
    transform: "translate(-70.26 119.05) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.18,
    y: 276.94,
    width: 2.62,
    height: 2.62,
    transform: "translate(-70.26 119.05) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.69,
    y: 287.59,
    width: 2.62,
    height: 2.62,
    transform: "translate(-73.41 120.66) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.69,
    y: 287.59,
    width: 2.62,
    height: 2.62,
    transform: "translate(-73.41 120.66) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.2,
    y: 298.24,
    width: 2.62,
    height: 2.62,
    transform: "translate(-76.56 122.28) rotate(-18.24)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.2,
    y: 298.24,
    width: 2.62,
    height: 2.62,
    transform: "translate(-76.56 122.28) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.71,
    y: 308.88,
    width: 2.62,
    height: 2.62,
    transform: "translate(-79.74 123.96) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.71,
    y: 308.88,
    width: 2.62,
    height: 2.62,
    transform: "translate(-79.74 123.96) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.82,
    y: 290.97,
    width: 2.62,
    height: 3.92,
    transform: "translate(-74.02 125) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.35,
    y: 265.24,
    width: 2.62,
    height: 4.03,
    transform: "translate(-66.4 121.04) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.26,
    y: 258.87,
    width: 2.62,
    height: 4.09,
    transform: "translate(-64.51 120.05) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.91,
    y: 297.17,
    width: 2.62,
    height: 4.19,
    transform: "translate(-75.9 125.98) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.3,
    y: 280.27,
    width: 2.62,
    height: 3.98,
    transform: "translate(-70.85 123.36) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.39,
    y: 286.53,
    width: 2.62,
    height: 4.14,
    transform: "translate(-72.73 124.33) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.83,308.33l.06.2,2.49-.8-.07-.22Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.83,258.12c-.66-.49-1-.73-1-.73-.6,0-1.19-.05-1.78-.07l.51,1.56Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.78,
    y: 269.57,
    width: 2.62,
    height: 4.03,
    transform: "translate(-67.69 121.71) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.34,
    y: 301.67,
    width: 2.62,
    height: 3.87,
    transform: "translate(-77.19 126.65) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.87,
    y: 275.88,
    width: 2.62,
    height: 4.08,
    transform: "translate(-69.56 122.68) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.69,259.38l2.48-.82-.08-.25-.26-.19-2.31.76Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.69,259.38l2.48-.82-.08-.25-.26-.19-2.31.76Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.07,
    y: 269.15,
    width: 2.62,
    height: 0.53,
    transform: "translate(-67.04 121.37) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.07,
    y: 269.15,
    width: 2.62,
    height: 0.53,
    transform: "translate(-67.04 121.37) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.59,
    y: 279.85,
    width: 2.62,
    height: 0.53,
    transform: "translate(-70.22 123.03) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.59,
    y: 279.85,
    width: 2.62,
    height: 0.53,
    transform: "translate(-70.22 123.03) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.12,
    y: 290.55,
    width: 2.62,
    height: 0.53,
    transform: "translate(-73.39 124.67) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.12,
    y: 290.55,
    width: 2.62,
    height: 0.53,
    transform: "translate(-73.39 124.67) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.65,
    y: 301.25,
    width: 2.62,
    height: 0.53,
    transform: "translate(-76.56 126.3) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.65,
    y: 301.25,
    width: 2.62,
    height: 0.53,
    transform: "translate(-76.56 126.3) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.31,
    y: 262.79,
    width: 2.62,
    height: 2.62,
    transform: "translate(-65.46 120.56) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.31,
    y: 262.79,
    width: 2.62,
    height: 2.62,
    transform: "translate(-65.46 120.56) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.82,
    y: 273.43,
    width: 2.62,
    height: 2.62,
    transform: "translate(-68.63 122.22) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.82,
    y: 273.43,
    width: 2.62,
    height: 2.62,
    transform: "translate(-68.63 122.22) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.33,
    y: 284.08,
    width: 2.62,
    height: 2.62,
    transform: "translate(-71.78 123.82) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.33,
    y: 284.08,
    width: 2.62,
    height: 2.62,
    transform: "translate(-71.78 123.82) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.84,
    y: 294.73,
    width: 2.62,
    height: 2.62,
    transform: "translate(-74.94 125.46) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.84,
    y: 294.73,
    width: 2.62,
    height: 2.62,
    transform: "translate(-74.94 125.46) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.35,
    y: 305.37,
    width: 2.62,
    height: 2.62,
    transform: "translate(-78.08 127.07) rotate(-18.24)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.35,
    y: 305.37,
    width: 2.62,
    height: 2.62,
    transform: "translate(-78.08 127.07) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.74,281l-.45-1,.34,1.05Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.28,298.16l.09,0c-.32-1.41-.66-2.76-1-4.08l-.39.13Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.75,287.46l.51-.17c-.48-1.34-1-2.63-1.48-3.87l-.33.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.14,291.69l.49-.16c-.38-1.28-.78-2.53-1.2-3.73l-.51.17Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.6,299.14c0-.17-.07-.33-.11-.49l-.05,0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.92,288l.51-.17c-.06-.17-.12-.34-.17-.51l-.51.17Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.92,288l.51-.17c-.06-.17-.12-.34-.17-.51l-.51.17Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.44,298.67l.05,0-.12-.52-.09,0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.44,298.67l.05,0-.12-.52-.09,0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.45,283.53l.33-.11c-.34-.82-.69-1.63-1-2.41l-.11,0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.45,283.53l.33-.11c-.34-.82-.69-1.63-1-2.41l-.11,0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,294.18l.39-.13q-.35-1.29-.72-2.52l-.49.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,294.18l.39-.13q-.35-1.29-.72-2.52l-.49.16Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.62,271.28l-.51.16,1.18,3.59.29.23.32-.1Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.45,270.77l-.39-1.17-.45.33.33,1Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.01,
    y: 270.84,
    width: 0.53,
    height: 0.53,
    transform: "translate(-69.62 108.56) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.01,
    y: 270.84,
    width: 0.53,
    height: 0.53,
    transform: "translate(-69.62 108.56) rotate(-18.24)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.58,275.26l.49.43-.17-.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.58,275.26l.49.43-.17-.53Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.15,267.24l-1.19-3.6-.49.24,1.17,3.53Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.08,
    y: 306.03,
    width: 0.53,
    height: 4.19,
    transform: "translate(-80.02 117.99) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.51,
    y: 310.53,
    width: 0.53,
    height: 3.87,
    transform: "translate(-81.32 118.68) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.99,
    y: 299.83,
    width: 0.53,
    height: 3.92,
    transform: "translate(-78.11 116.96) rotate(-18.24)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.56,
    y: 295.39,
    width: 0.53,
    height: 4.14,
    transform: "translate(-76.89 116.43) rotate(-18.26)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.47,
    y: 289.13,
    width: 0.53,
    height: 3.98,
    transform: "translate(-74.97 115.37) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.95,
    y: 278.43,
    width: 0.53,
    height: 4.03,
    transform: "translate(-71.81 113.75) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.04,
    y: 284.74,
    width: 0.53,
    height: 4.08,
    transform: "translate(-73.69 114.71) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.43,
    y: 267.73,
    width: 0.53,
    height: 4.09,
    transform: "translate(-68.65 112.1) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.52,
    y: 274.1,
    width: 0.53,
    height: 4.03,
    transform: "translate(-70.55 113.13) rotate(-18.26)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.71,
    y: 267.31,
    width: 0.53,
    height: 0.53,
    transform: "translate(-68.07 111.96) rotate(-18.28)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.71,
    y: 267.31,
    width: 0.53,
    height: 0.53,
    transform: "translate(-68.07 111.96) rotate(-18.28)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.24,
    y: 278.01,
    width: 0.53,
    height: 0.53,
    transform: "translate(-71.17 113.42) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.24,
    y: 278.01,
    width: 0.53,
    height: 0.53,
    transform: "translate(-71.17 113.42) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.76,
    y: 288.71,
    width: 0.53,
    height: 0.53,
    transform: "translate(-74.31 114.99) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.76,
    y: 288.71,
    width: 0.53,
    height: 0.53,
    transform: "translate(-74.31 114.99) rotate(-18.24)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.29,
    y: 299.41,
    width: 0.53,
    height: 0.53,
    transform: "translate(-77.52 116.7) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.29,
    y: 299.41,
    width: 0.53,
    height: 0.53,
    transform: "translate(-77.52 116.7) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.82,
    y: 310.1,
    width: 0.53,
    height: 0.53,
    transform: "translate(-80.67 118.3) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.82,
    y: 310.1,
    width: 0.53,
    height: 0.53,
    transform: "translate(-80.67 118.3) rotate(-18.24)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.48,
    y: 271.65,
    width: 0.53,
    height: 2.62,
    transform: "translate(-69.6 112.61) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.48,
    y: 271.65,
    width: 0.53,
    height: 2.62,
    transform: "translate(-69.6 112.61) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.99,
    y: 282.29,
    width: 0.53,
    height: 2.62,
    transform: "translate(-72.72 114.17) rotate(-18.24)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.99,
    y: 282.29,
    width: 0.53,
    height: 2.62,
    transform: "translate(-72.72 114.17) rotate(-18.24)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.5,
    y: 292.94,
    width: 0.53,
    height: 2.62,
    transform: "translate(-75.93 115.92) rotate(-18.26)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.5,
    y: 292.94,
    width: 0.53,
    height: 2.62,
    transform: "translate(-75.93 115.92) rotate(-18.26)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.01,
    y: 303.59,
    width: 0.53,
    height: 2.62,
    transform: "translate(-79.09 117.55) rotate(-18.26)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.01,
    y: 303.59,
    width: 0.53,
    height: 2.62,
    transform: "translate(-79.09 117.55) rotate(-18.26)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.13,314.38l.81,2.46.51-.16-.82-2.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.13,314.38l.81,2.46.51-.16-.82-2.47Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.7,
    y: 259.92,
    width: 0.53,
    height: 3.97,
    transform: "translate(-65.72 114.61) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.21,
    y: 307,
    width: 0.53,
    height: 3.87,
    transform: "translate(-79.66 121.82) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.69,
    y: 296.3,
    width: 0.53,
    height: 3.92,
    transform: "translate(-76.49 120.18) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.26,
    y: 291.86,
    width: 0.53,
    height: 4.14,
    transform: "translate(-75.24 119.58) rotate(-18.26)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.22,
    y: 270.57,
    width: 0.53,
    height: 4.03,
    transform: "translate(-68.88 116.24) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.65,
    y: 274.9,
    width: 0.53,
    height: 4.03,
    transform: "translate(-70.19 116.97) rotate(-18.26)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.17,
    y: 285.6,
    width: 0.53,
    height: 3.98,
    transform: "translate(-73.34 118.56) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.64,313.34l0,.07.51-.17,0-.07Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.13,
    y: 264.2,
    width: 0.53,
    height: 4.09,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -67, 115.26)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.74,
    y: 281.21,
    width: 0.53,
    height: 4.08,
    transform: "translate(-72.05 117.9) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.78,
    y: 302.5,
    width: 0.53,
    height: 4.19,
    transform: "translate(-78.37 121.15) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.41,
    y: 263.78,
    width: 0.53,
    height: 0.53,
    transform: "translate(-66.33 114.88) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.41,
    y: 263.78,
    width: 0.53,
    height: 0.53,
    transform: "translate(-66.33 114.88) rotate(-18.24)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.93,
    y: 274.48,
    width: 0.53,
    height: 0.53,
    transform: "translate(-69.52 116.57) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.93,
    y: 274.48,
    width: 0.53,
    height: 0.53,
    transform: "translate(-69.52 116.57) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.46,
    y: 285.18,
    width: 0.53,
    height: 0.53,
    transform: "translate(-72.7 118.23) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.46,
    y: 285.18,
    width: 0.53,
    height: 0.53,
    transform: "translate(-72.7 118.23) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.99,
    y: 295.88,
    width: 0.53,
    height: 0.53,
    transform: "translate(-75.84 119.8) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.99,
    y: 295.88,
    width: 0.53,
    height: 0.53,
    transform: "translate(-75.84 119.8) rotate(-18.24)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.52,
    y: 306.58,
    width: 0.53,
    height: 0.53,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -79.04, 121.49)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.52,
    y: 306.58,
    width: 0.53,
    height: 0.53,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -79.04, 121.49)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.6,259.94l-.15-.45-.51.15.15.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.6,259.94l-.15-.45-.51.15.15.47Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.18,
    y: 268.12,
    width: 0.53,
    height: 2.62,
    transform: "translate(-67.95 115.78) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.18,
    y: 268.12,
    width: 0.53,
    height: 2.62,
    transform: "translate(-67.95 115.78) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.69,
    y: 278.77,
    width: 0.53,
    height: 2.62,
    transform: "translate(-71.11 117.41) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.69,
    y: 278.77,
    width: 0.53,
    height: 2.62,
    transform: "translate(-71.11 117.41) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.2,
    y: 289.41,
    width: 0.53,
    height: 2.62,
    transform: "translate(-74.24 119) rotate(-18.24)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.2,
    y: 289.41,
    width: 0.53,
    height: 2.62,
    transform: "translate(-74.24 119) rotate(-18.24)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.71,
    y: 300.06,
    width: 0.53,
    height: 2.62,
    transform: "translate(-77.43 120.69) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.71,
    y: 300.06,
    width: 0.53,
    height: 2.62,
    transform: "translate(-77.43 120.69) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.22,
    y: 310.7,
    width: 0.53,
    height: 2.62,
    transform: "translate(-80.58 122.32) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.22,
    y: 310.7,
    width: 0.53,
    height: 2.62,
    transform: "translate(-80.58 122.32) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.47,
    y: 298.98,
    width: 0.53,
    height: 4.19,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -76.74, 124.34)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.96,
    y: 288.33,
    width: 0.53,
    height: 4.14,
    transform: "translate(-73.59 122.76) rotate(-18.26)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.9,
    y: 303.47,
    width: 0.53,
    height: 3.87,
    transform: "translate(-78.03 125.01) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.87,
    y: 282.08,
    width: 0.53,
    height: 3.98,
    transform: "translate(-71.71 121.78) rotate(-18.26)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.83,
    y: 260.68,
    width: 0.53,
    height: 4.09,
    transform: "translate(-65.35 118.43) rotate(-18.24)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.34,309.81l.05.16.51-.16,0-.17Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.54,260.19l-.91-2.76-.54.05,1,2.87Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.39,
    y: 292.77,
    width: 0.53,
    height: 3.92,
    transform: "translate(-74.83 123.3) rotate(-18.24)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.92,
    y: 267.04,
    width: 0.53,
    height: 4.03,
    transform: "translate(-67.25 119.44) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.44,
    y: 277.69,
    width: 0.53,
    height: 4.08,
    transform: "translate(-70.4 121.05) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.35,
    y: 271.38,
    width: 0.53,
    height: 4.03,
    transform: "translate(-68.53 120.1) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.11,
    y: 260.26,
    width: 0.53,
    height: 0.53,
    transform: "translate(-64.75 118.22) rotate(-18.26)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.11,
    y: 260.26,
    width: 0.53,
    height: 0.53,
    transform: "translate(-64.75 118.22) rotate(-18.26)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.63,
    y: 270.96,
    width: 0.53,
    height: 0.53,
    transform: "translate(-67.89 119.76) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.63,
    y: 270.96,
    width: 0.53,
    height: 0.53,
    transform: "translate(-67.89 119.76) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.16,
    y: 281.65,
    width: 0.53,
    height: 0.53,
    transform: "translate(-71.04 121.36) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.16,
    y: 281.65,
    width: 0.53,
    height: 0.53,
    transform: "translate(-71.04 121.36) rotate(-18.24)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.69,
    y: 292.35,
    width: 0.53,
    height: 0.53,
    transform: "translate(-74.25 123.1) rotate(-18.26)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.69,
    y: 292.35,
    width: 0.53,
    height: 0.53,
    transform: "translate(-74.25 123.1) rotate(-18.26)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.21,
    y: 303.05,
    width: 0.53,
    height: 0.53,
    transform: "translate(-77.38 124.64) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.21,
    y: 303.05,
    width: 0.53,
    height: 0.53,
    transform: "translate(-77.38 124.64) rotate(-18.24)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.88,
    y: 264.59,
    width: 0.53,
    height: 2.62,
    transform: "translate(-66.3 118.92) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.88,
    y: 264.59,
    width: 0.53,
    height: 2.62,
    transform: "translate(-66.3 118.92) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.39,
    y: 275.24,
    width: 0.53,
    height: 2.62,
    transform: "translate(-69.44 120.51) rotate(-18.24)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.39,
    y: 275.24,
    width: 0.53,
    height: 2.62,
    transform: "translate(-69.44 120.51) rotate(-18.24)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.9,
    y: 285.89,
    width: 0.53,
    height: 2.62,
    transform: "translate(-72.62 122.22) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.9,
    y: 285.89,
    width: 0.53,
    height: 2.62,
    transform: "translate(-72.62 122.22) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.41,
    y: 296.53,
    width: 0.53,
    height: 2.62,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -75.81, 123.93)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.41,
    y: 296.53,
    width: 0.53,
    height: 2.62,
    transform: "matrix(0.95, -0.31, 0.31, 0.95, -75.81, 123.93)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.92,
    y: 307.18,
    width: 0.53,
    height: 2.62,
    transform: "translate(-78.92 125.45) rotate(-18.24)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.92,
    y: 307.18,
    width: 0.53,
    height: 2.62,
    transform: "translate(-78.92 125.45) rotate(-18.24)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.08,
    y: 289.25,
    width: 0.53,
    height: 3.92,
    transform: "translate(-73.19 126.47) rotate(-18.24)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,306.28l.08.25.51-.16-.08-.25Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.77,267.36l-.73-2.22-.92-1.08,1.14,3.47Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.17,
    y: 295.45,
    width: 0.53,
    height: 4.19,
    transform: "translate(-75.1 127.52) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.14,
    y: 274.16,
    width: 0.53,
    height: 4.08,
    transform: "translate(-68.76 124.22) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.65,
    y: 284.8,
    width: 0.53,
    height: 4.14,
    transform: "translate(-71.93 125.87) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.56,
    y: 278.55,
    width: 0.53,
    height: 3.98,
    transform: "translate(-70.07 124.96) rotate(-18.26)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.6,
    y: 299.95,
    width: 0.53,
    height: 3.87,
    transform: "translate(-76.4 128.24) rotate(-18.26)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.05,
    y: 267.85,
    width: 0.53,
    height: 4.03,
    transform: "translate(-66.86 123.2) rotate(-18.24)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.33,
    y: 267.43,
    width: 0.53,
    height: 0.53,
    transform: "translate(-66.24 122.91) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.33,
    y: 267.43,
    width: 0.53,
    height: 0.53,
    transform: "translate(-66.24 122.91) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.86,
    y: 278.13,
    width: 0.53,
    height: 0.53,
    transform: "translate(-69.41 124.55) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.86,
    y: 278.13,
    width: 0.53,
    height: 0.53,
    transform: "translate(-69.41 124.55) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.39,
    y: 288.82,
    width: 0.53,
    height: 0.53,
    transform: "translate(-72.59 126.22) rotate(-18.25)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.39,
    y: 288.82,
    width: 0.53,
    height: 0.53,
    transform: "translate(-72.59 126.22) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.91,
    y: 299.52,
    width: 0.53,
    height: 0.53,
    transform: "translate(-75.74 127.81) rotate(-18.24)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.91,
    y: 299.52,
    width: 0.53,
    height: 0.53,
    transform: "translate(-75.74 127.81) rotate(-18.24)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.09,
    y: 271.71,
    width: 0.53,
    height: 2.62,
    transform: "translate(-67.8 123.68) rotate(-18.24)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.09,
    y: 271.71,
    width: 0.53,
    height: 2.62,
    transform: "translate(-67.8 123.68) rotate(-18.24)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.6,
    y: 282.36,
    width: 0.53,
    height: 2.62,
    transform: "translate(-70.95 125.31) rotate(-18.24)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.6,
    y: 282.36,
    width: 0.53,
    height: 2.62,
    transform: "translate(-70.95 125.31) rotate(-18.24)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.11,
    y: 293,
    width: 0.53,
    height: 2.62,
    transform: "translate(-74.16 127.07) rotate(-18.26)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.11,
    y: 293,
    width: 0.53,
    height: 2.62,
    transform: "translate(-74.16 127.07) rotate(-18.26)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.62,
    y: 303.65,
    width: 0.53,
    height: 2.62,
    transform: "translate(-77.28 128.63) rotate(-18.25)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.62,
    y: 303.65,
    width: 0.53,
    height: 2.62,
    transform: "translate(-77.28 128.63) rotate(-18.25)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.45,291.12a48.88,48.88,0,0,0-7.23-10.43c1.7-1.6,4.19-2.55,7.63-2.25A21.85,21.85,0,0,1,317.45,291.12Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.49 292.61 295.8 289.5 295.91 293.69 314.03 295.47 314.49 292.61",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.49 292.61 295.8 289.5 295.91 293.69 314.03 295.47 314.49 292.61",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.63,315.8l1.35,2.28a1.39,1.39,0,0,1-.44,1.89L271.46,396.9l-2.78-4.7,119-76.86A1.4,1.4,0,0,1,389.63,315.8Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.63,315.8l1.35,2.28a1.39,1.39,0,0,1-.44,1.89L271.46,396.9l-2.78-4.7,119-76.86A1.4,1.4,0,0,1,389.63,315.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.71,394.75s-9.46-13.8-6.53-28.41a82.42,82.42,0,0,0,12.48,24.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.71,394.75s-9.46-13.8-6.53-28.41a82.42,82.42,0,0,0,12.48,24.9Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.69,398.11s7.54,14.95,21.74,19.43a82.72,82.72,0,0,1-15.79-22.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.69,398.11s7.54,14.95,21.74,19.43a82.72,82.72,0,0,1-15.79-22.94Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.65,
    y: 389.5,
    width: 6.74,
    height: 9.95,
    transform: "translate(67.8 827.63) rotate(-120.58)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.65,
    y: 389.5,
    width: 6.74,
    height: 9.95,
    transform: "translate(67.8 827.63) rotate(-120.58)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.65,315.12l-.09,10.24,8.85-1.35s1.07-7.15-4.11-10.11Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.8 328.93 386.28 329.24 385.41 324.01 376.56 325.36 378.8 328.93",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.21 396.77 404.67 404.09 387.76 405.86 387.31 398.54 404.21 396.77",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,404.39a.17.17,0,0,0-.19-.06.16.16,0,0,0-.12.15c0,.13-.21,3.07.62,4a.9.9,0,0,0,.6.32.65.65,0,0,0,.69-.32c.25-.46,0-1.33-.43-2.18A13.35,13.35,0,0,0,405,404.39Zm0,.62c.77,1.15,1.57,2.82,1.29,3.33,0,.07-.11.16-.36.14a.51.51,0,0,1-.37-.2,1.19,1.19,0,0,1-.18-.29A8.05,8.05,0,0,1,405,405Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.94,404.34a.19.19,0,0,0-.18,0c-.07,0-1.76,1.08-2.05,2.25a1.34,1.34,0,0,0,.15,1c.26.41.53.43.72.37.81-.24,1.47-2.51,1.45-3.48a.19.19,0,0,0,0-.07A.27.27,0,0,0,404.94,404.34Zm-1.89,2.34a4.11,4.11,0,0,1,1.62-1.85c-.1,1.05-.7,2.66-1.19,2.81,0,0-.16.05-.32-.22a.41.41,0,0,1-.05-.09A.9.9,0,0,1,403.05,406.68Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.75,404.16,400.27,397a.64.64,0,0,1,.18-.78l5.24-4.14a1.07,1.07,0,0,1,1.63.38c1.21,2.63,2.88,6.46,4.46,9.73,1.84,3.83,3.64,7,5.81,11.51,1.31,2.71-1.07,4.79-1.87,3.78-3.62-4.63-5.78-8.79-10.69-11.92A3.39,3.39,0,0,1,403.75,404.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.62,410.05s-54.09,9.6-71.09,4.89c-10.64-2.95-11-31.5-9-57.44.58-7.68,1.39-15.13,2.18-21.62,1.54-12.57,3.06-21.53,3.06-21.53l43.07-9.52s3.75,16.56-1.84,29.27A22.38,22.38,0,0,1,349.94,347s-3.79,12.11-6.8,24.45c-2.75,11.29-4.87,22.77-2.85,25.38,3,3.86,56.67-.05,56.67-.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.62,410.05s-54.09,9.6-71.09,4.89c-10.64-2.95-11-31.5-9-57.44.58-7.68,1.39-15.13,2.18-21.62,1.54-12.57,3.06-21.53,3.06-21.53l43.07-9.52s3.75,16.56-1.84,29.27A22.38,22.38,0,0,1,349.94,347s-3.79,12.11-6.8,24.45c-2.75,11.29-4.87,22.77-2.85,25.38,3,3.86,56.67-.05,56.67-.05Z",
    style: {
      fill: "#fafafa",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.45,347.58c-.32,3.22-.62,6.55-.88,9.92,6.1,4.12,16.6,10.43,25.57,13.94,2.62-10.74,5.82-21.29,6.61-23.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.73,410.22a.18.18,0,0,0,.14-.14.16.16,0,0,0-.09-.18c-.11-.06-2.67-1.53-3.89-1.19a.82.82,0,0,0-.55.4.66.66,0,0,0,0,.76c.3.43,1.21.55,2.15.55A13.29,13.29,0,0,0,307.73,410.22Zm-.56-.26c-1.37.19-3.22.18-3.56-.29-.05-.06-.09-.17,0-.39A.55.55,0,0,1,304,409a1.22,1.22,0,0,1,.34,0A7.88,7.88,0,0,1,307.17,410Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.8,410.19a.17.17,0,0,0,.07-.16c0-.08-.21-2.06-1.14-2.82a1.22,1.22,0,0,0-1-.3c-.48,0-.62.29-.65.48-.13.83,1.62,2.42,2.51,2.82h.07A.19.19,0,0,0,307.8,410.19Zm-1.29-2.72a4.18,4.18,0,0,1,1,2.27c-.9-.55-2.1-1.79-2-2.29,0,0,0-.16.34-.2h.11A.91.91,0,0,1,306.51,407.47Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.57 409.71 309.75 412.41 302.81 396.89 309.63 394.19 316.57 409.71",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.48,409.2h8a.63.63,0,0,1,.62.5l1.45,6.52a1.06,1.06,0,0,1-1.06,1.3c-2.89,0-7.06-.21-10.69-.21-4.25,0-7.92.23-12.9.23-3,0-3.84-3.05-2.58-3.32,5.74-1.26,10.42-1.39,15.38-4.45A3.41,3.41,0,0,1,308.48,409.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.77,305.36l-3.44,32.83c-1.7,3.91-10.78,11.08-15.06,11.63a103.42,103.42,0,0,1-10.46.7c-6.08.14-12.57-.07-18.47-.35-3.78-.18-7.31-.4-10.34-.58-5.52-.32-9.37-.52-9.91-.18-2,1.24,16.42,51.91,16.42,51.91l-11.3.24S278,358.35,275.66,344c-.87-5.3-1.61-11.9,8.48-17,6.15-3.09,23.17-4.43,33-5,4.35-.23,7.3-.3,7.3-.3l-.31-1.36-1.35-6.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.77,305.36l-3.44,32.83c-1.7,3.91-10.78,11.08-15.06,11.63a103.42,103.42,0,0,1-10.46.7c-6.08.14-12.57-.07-18.47-.35-3.78-.18-7.31-.4-10.34-.58-5.52-.32-9.37-.52-9.91-.18-2,1.24,16.42,51.91,16.42,51.91l-11.3.24S278,358.35,275.66,344c-.87-5.3-1.61-11.9,8.48-17,6.15-3.09,23.17-4.43,33-5,4.35-.23,7.3-.3,7.3-.3l-.31-1.36-1.35-6.06Z",
    style: {
      fill: "#fafafa",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.16,324.87l8.37-1.63a91.45,91.45,0,0,1,0,10.84l-4.1,2.85-3.44-1.5A93,93,0,0,0,348.16,324.87Z",
    style: {
      opacity: 0.2
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "325.48 314.65 326.19 318.1 322.07 318.93 322.37 315.31 325.48 314.65"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "339.79 311.63 340.56 315.21 327.74 317.79 326.98 314.33 339.79 311.63"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "355.77 308.26 356.53 312 342.19 314.88 341.44 311.28 355.77 308.26"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "367.03 309.88 358.2 311.66 358.19 311.66 357.42 307.91 366.19 306.06 367.03 309.88"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M275.08,306l-4.44-2.69A4,4,0,0,0,267,303l-2.93,1.24a4,4,0,0,0-2.17,5.06l.84,2.22a4,4,0,0,0,3,2.5l4.87.94s4.62-.26,6.81-3.56Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.15,275.26a221.2,221.2,0,0,1-4.27,22.81,52.77,52.77,0,0,1-2.81,9c-4.75,10.06-25.53,7-34.4,5.39l.44-6.55c4.91-.5,9.94-1,14.64-1.75,3.08-.56,6.41-1.07,8.82-2.49.2-.14.3-.27.12-.16a1.47,1.47,0,0,0-.37.4c-.09.11-.19.32-.16.23s0,0,0-.1c2-9.19,3.15-19.46,4.88-28.75l13.09,2Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,276.68l-.82,16.61,16.11,1a82.66,82.66,0,0,0,4.47-18.06C318.86,265.66,300.43,266.07,298,276.68Z",
    style: {
      fill: "#FBB12D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.26,
    y: 276.38,
    width: 4.19,
    height: 0.53,
    transform: "translate(-7.35 545.04) rotate(-83.37)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.89,
    y: 280.92,
    width: 3.87,
    height: 0.53,
    transform: "translate(-12.3 548.55) rotate(-83.37)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.16,272l.23-2-.57.32-.19,1.62Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.93,
    y: 287.54,
    width: 4.24,
    height: 0.53,
    transform: "translate(-19.57 553.65) rotate(-83.37)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.48 290.42 300.13 293.48 300.66 293.51 301.01 290.48 300.48 290.42",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.08,
    y: 282.22,
    width: 3.87,
    height: 0.53,
    transform: "translate(-3.69 560.82) rotate(-83.38)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.45,
    y: 277.68,
    width: 4.19,
    height: 0.53,
    transform: "translate(1.27 557.33) rotate(-83.37)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.12,
    y: 288.84,
    width: 4.24,
    height: 0.53,
    transform: "translate(-10.96 565.92) rotate(-83.38)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.35,273.3l.4-3.44a4.91,4.91,0,0,0-.5-.28l-.43,3.66Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.67 291.72 311.38 294.21 311.92 294.25 312.2 291.78 311.67 291.72",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.5,
    y: 287.15,
    width: 4.24,
    height: 2.62,
    transform: "translate(-15.3 559.74) rotate(-83.37)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.83,
    y: 275.99,
    width: 4.19,
    height: 2.62,
    transform: "translate(-3.06 551.16) rotate(-83.37)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.76,272.77l.46-3.9-2.24-.26-.37.05-.44,3.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.02 290.95 304.69 293.77 307.3 293.94 307.62 291.25 305.02 290.95",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.46,
    y: 280.52,
    width: 3.87,
    height: 2.62,
    transform: "translate(-8.04 554.63) rotate(-83.37)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.04,
    y: 283.4,
    width: 2.62,
    height: 4.08,
    transform: "translate(-9 560.76) rotate(-83.37)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.41,
    y: 282.65,
    width: 2.62,
    height: 4.03,
    transform: "translate(-14.11 553.49) rotate(-83.37)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.34 283.07 297.75 282.66 297.62 285.27 301.04 285.67 301.34 283.07",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.76,287l2.82.33c.22-.81.45-1.67.67-2.55l-3.19-.37Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.14,
    y: 284.14,
    width: 2.62,
    height: 0.53,
    transform: "translate(-15.89 550.96) rotate(-83.36)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.14,
    y: 284.14,
    width: 2.62,
    height: 0.53,
    transform: "translate(-15.89 550.96) rotate(-83.36)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.33,
    y: 285.44,
    width: 2.62,
    height: 0.53,
    transform: "translate(-7.23 563.29) rotate(-83.37)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.33,
    y: 285.44,
    width: 2.62,
    height: 0.53,
    transform: "translate(-7.23 563.29) rotate(-83.37)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.71,
    y: 283.74,
    width: 2.62,
    height: 2.62,
    transform: "translate(-11.56 557.12) rotate(-83.37)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.71,
    y: 283.74,
    width: 2.62,
    height: 2.62,
    transform: "translate(-11.56 557.12) rotate(-83.37)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.33,274.54l.3-2.6-1.72-.2a9.73,9.73,0,0,0-1.9,2.41Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.05,275.9l3.74.43v-.05a7.83,7.83,0,0,0-.17-2.6l-3.28-.38Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.33,
    y: 272.26,
    width: 2.62,
    height: 4.08,
    transform: "translate(3.22 552.22) rotate(-83.38)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.71,
    y: 271.52,
    width: 2.62,
    height: 4.03,
    transform: "translate(-1.93 544.9) rotate(-83.37)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.44,
    y: 273,
    width: 2.62,
    height: 0.53,
    transform: "translate(-3.62 542.47) rotate(-83.38)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.44,
    y: 273,
    width: 2.62,
    height: 0.53,
    transform: "translate(-3.62 542.47) rotate(-83.38)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.63,
    y: 274.3,
    width: 2.62,
    height: 0.53,
    transform: "translate(4.96 554.71) rotate(-83.37)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.63,
    y: 274.3,
    width: 2.62,
    height: 0.53,
    transform: "translate(4.96 554.71) rotate(-83.37)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.01,
    y: 272.61,
    width: 2.62,
    height: 2.62,
    transform: "translate(0.62 548.53) rotate(-83.37)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.01,
    y: 272.61,
    width: 2.62,
    height: 2.62,
    transform: "translate(0.62 548.53) rotate(-83.37)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.2,291.78l1.95.23c.06-.17.11-.34.17-.52l-2.05-.24Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.55 289.89 297.41 289.52 297.38 290.06 300.48 290.42 300.55 289.89",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.41,
    y: 289.18,
    width: 0.53,
    height: 4.08,
    transform: "translate(-15.38 565.16) rotate(-83.36)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.78,
    y: 288.43,
    width: 0.53,
    height: 4.03,
    transform: "translate(-20.42 557.96) rotate(-83.37)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.51,
    y: 289.92,
    width: 0.53,
    height: 0.53,
    transform: "translate(-22.26 555.36) rotate(-83.35)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.51,
    y: 289.92,
    width: 0.53,
    height: 0.53,
    transform: "translate(-22.26 555.36) rotate(-83.35)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.7,
    y: 291.22,
    width: 0.53,
    height: 0.53,
    transform: "translate(-13.56 567.74) rotate(-83.37)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.7,
    y: 291.22,
    width: 0.53,
    height: 0.53,
    transform: "translate(-13.56 567.74) rotate(-83.37)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.08,
    y: 289.52,
    width: 0.53,
    height: 2.62,
    transform: "translate(-17.89 561.58) rotate(-83.37)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.08,
    y: 289.52,
    width: 0.53,
    height: 2.62,
    transform: "translate(-17.89 561.58) rotate(-83.37)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.85 278.7 297.96 278.25 297.94 278.78 301.78 279.23 301.85 278.7",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.71,
    y: 277.99,
    width: 0.53,
    height: 4.08,
    transform: "translate(-3.09 556.59) rotate(-83.37)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.5,280.59l3.59.42c0-.18.06-.35.1-.53l-3.62-.42Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.08,
    y: 277.24,
    width: 0.53,
    height: 4.03,
    transform: "translate(-8.17 549.35) rotate(-83.37)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.81,
    y: 278.73,
    width: 0.53,
    height: 0.53,
    transform: "translate(-9.85 546.93) rotate(-83.39)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.81,
    y: 278.73,
    width: 0.53,
    height: 0.53,
    transform: "translate(-9.85 546.93) rotate(-83.39)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 280.03,
    width: 0.53,
    height: 0.53,
    transform: "translate(-1.3 559.13) rotate(-83.37)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 280.03,
    width: 0.53,
    height: 0.53,
    transform: "translate(-1.3 559.13) rotate(-83.37)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.38,
    y: 278.33,
    width: 0.53,
    height: 2.62,
    transform: "translate(-5.63 552.96) rotate(-83.37)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.38,
    y: 278.33,
    width: 0.53,
    height: 2.62,
    transform: "translate(-5.63 552.96) rotate(-83.37)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.54,269.25a10.89,10.89,0,0,0-3.28-.71l0,.33Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.26,268.54a13.43,13.43,0,0,0-2.28.07l2.24.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.26,268.54a13.43,13.43,0,0,0-2.28.07l2.24.26Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.92,282.36l4.66-11.31s-6.85,2.3-7-5.9c0,0-3.78,11.52-13.05,4.26,0,0-.69,8.08-3,10.76s-7.25,2.8-7.25,2.8,3.48,3.66,3.55,5.75-3.74,4.45-3.74,4.45l9.68,2.76s-3.79-.77-3.61-5.62,5.05-12.42,12.76-15.21S261.79,274.91,258.92,282.36Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.fa53d55fa220f8247bccf467dccbf19d.svg";
export { ForwardRef as ReactComponent };